//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockDisplayItem } from './WebsiteBlockDisplayItem';
import { WebsiteBlockEmbedContentType, WebsiteBlockEmbedType, WebsiteBlockType } from './Enums';

export class WebsiteBlockEmbedDisplayItem extends WebsiteBlockDisplayItem {
    Source: string | null = null;
    IsFullWidth: boolean = false;
    ContentType: WebsiteBlockEmbedContentType = WebsiteBlockEmbedContentType.Custom;
    EmbedType: WebsiteBlockEmbedType = WebsiteBlockEmbedType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.Embed;

    constructor(initializer?: Partial<Omit<WebsiteBlockEmbedDisplayItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockEmbedDisplayItem";
}
